
import { Vue, Component, Prop } from "vue-property-decorator";
import Job from "@/lib/job/job";
interface ExamItem {
  id: number;
  name: string;
  remark: string;
  isEnableAi: boolean;
  examTypeFlag: boolean;
}
@Component({})
export default class CandidateSelect extends Vue {
  @Prop({ type: String, default: "请输入面试名称或备注进行搜索" })
  placeholder?: string;
  @Prop({ type: String, default: "全部面试" })
  activeName!: string;

  searchValue = "";
  showOptions = false;
  page = 1;
  mounted() {
    console.log(this.$el);
    document.addEventListener("click", (e: any) => {
      // document.getElementsByClassName("select-options");
      if (e.target && !this.$el.contains(e.target)) {
        this.showOptions = false;
      }
    });
    this.optionsInit();
  }
  searchValueChange(value: any) {
    this.page = 1;
    this.getOptions().then(res => {
      this.optionsList = res;
    });
    this.$emit("searchValueChange", value);
  }
  clearData() {
    this.page = 1;
  }
  extendOptions() {
    this.showOptions = !this.showOptions;
  }
  load() {
    this.page += 1;
    this.getOptions().then((res: ExamItem[]) => {
      this.optionsList = this.optionsList.concat(res);
    });
  }
  optionsList: ExamItem[] = [];
  optionsInit() {
    this.page = 1;
    this.getOptions().then((res: any) => {
      this.optionsList = res;
    });
  }
  getOptions() {
    return new Promise<ExamItem[]>((resolve, reject) => {
      Job.getAllExam({
        nameOrRemark: this.searchValue,
        PageSize: 20,
        page: this.page
      })
        .then(res => {
          resolve(res.list);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
  activeItem = { name: "全部面试", examId: "" };
  optionsClick(item: any) {
    this.activeItem = item;
    this.$emit("change", this.activeItem);
    this.searchValue = "";
    this.optionsInit();
    this.showOptions = false;
  }
}
